import { Turbo } from "@hotwired/turbo-rails";
import "./controllers";

// Turn off turbo-drive by default unless "opted in"
Turbo.session.drive = false;
